module.exports = __webpack_public_path__ + "assets/img/a83b4dc90240792a676edb1551363c65.png";